import { createFileRoute } from "@tanstack/react-router";
import { loadStandalonePage } from "~/utils/content-fns";
import { BlockRenderer } from "~/components/blocks";
import { seo, seoLinks } from "~/utils/seo";

export const Route = createFileRoute("/c1-transform-2026/register")({
  loader: async () => {
    const page = await loadStandalonePage({
      data: { path: "c1-transform-2026-register.md" },
    });
    return {
      title: (page.title as string) || "",
      seo_title: page.seo_title as string | undefined,
      seo_description: page.seo_description as string | undefined,
      featured_image: page.featured_image as string | undefined,
      blocks: (page.blocks as any[]) || [],
    };
  },
  head: ({ loaderData }) => ({
    meta: seo({
      title: (loaderData as any)?.seo_title || (loaderData as any)?.title,
      description: (loaderData as any)?.seo_description,
      image: (loaderData as any)?.featured_image,
      noindex: true,
      url: "/c1-transform-2026/register",
    }),
    links: seoLinks({ url: "/c1-transform-2026/register" }),
  }),
  component: () => {
    const p = Route.useLoaderData() as any;
    return <BlockRenderer blocks={p.blocks || []} />;
  },
});
